import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=631eb770&"
import script from "./TopBar.vue?vue&type=script&lang=js&"
export * from "./TopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('631eb770')) {
      api.createRecord('631eb770', component.options)
    } else {
      api.reload('631eb770', component.options)
    }
    module.hot.accept("./TopBar.vue?vue&type=template&id=631eb770&", function () {
      api.rerender('631eb770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "backoffice/themes/base/src/components/TopBar/TopBar.vue"
export default component.exports